import { propTypes } from 'gatsby-plugin-image/dist/src/components/static-image.server';
import React, { useState } from 'react';

import chartsUtils from 'utils/charts.utils';

import ChartCombo, { ChartComboItem } from '../chartCombo/chartCombo';

// styles
import './datasetCombo.scss';

interface DatasetComboProps {
    value: ChartComboItem;
    onChange: (value: ChartComboItem) => void;
}

const DatasetCombo = (props: DatasetComboProps) => {
    const getOptions = () => {
        return chartsUtils.getDatasets().map((item) => {
            return {
                text: item.name,
                value: item.code,
            } as ChartComboItem;
        });
    };

    const handleChange = (value: ChartComboItem) => {
        props.onChange(value);
    };

    return (
        <div className="datasetCombo">
            <ChartCombo
                label="Einkommensgruppe"
                itemPrefix="Top"
                mode="combo"
                onChange={handleChange}
                options={getOptions()}
                selectedItem={props.value}
            ></ChartCombo>
        </div>
    );
};

export default DatasetCombo;
